import PropTypes from 'prop-types';
import classNames from 'classnames';

const StickyPanel = ({ name, show, mobileOnly, children }) => {
  const classes = classNames({
    'sticky-panel': true,
    'sticky-panel--mobile-only': mobileOnly,
  });

  return show ? (
    <div id={name} className={classes} data-testid={name} data-cy={name}>
      <div className="sticky-panel__inner">{children}</div>
    </div>
  ) : null;
};

StickyPanel.propTypes = {
  name: PropTypes.string,
  show: PropTypes.bool,
  mobileOnly: PropTypes.bool,
};

StickyPanel.defaultProps = {
  name: 'stickyPanel',
  show: true,
  mobileOnly: true,
};

export default StickyPanel;
